import firebase from "firebase/app";

export async function updateStudentScoring(additionalHeaders?: any) {
  let post_req =
    "https://functions-auth-handler-gdgn5rj5ca-ue.a.run.app/student_dashboard";

  let currentUser = firebase.auth().currentUser;
  let token = null;
  if (currentUser) token = await currentUser.getIdToken(true);
  if (!token) return;

  return fetch(post_req, {
    ...additionalHeaders,
    ...{
      method: "GET",
      headers: new Headers({
        "Content-Type": "application/x-www-form-urlencoded",
        Authorization: "Bearer " + token
      })
    }
  });
}

export async function updateTeacherScoring(additionalHeaders?: any) {
  let post_req =
    "https://functions-auth-handler-gdgn5rj5ca-ue.a.run.app/teacher_dashboard";

  let currentUser = firebase.auth().currentUser;
  let token = null;
  if (currentUser) token = await currentUser.getIdToken(true);

  if (!token) return;

  return fetch(post_req, {
    ...additionalHeaders,
    ...{
      method: "GET",
      headers: new Headers({
        "Content-Type": "application/x-www-form-urlencoded",
        Authorization: "Bearer " + token
      })
    }
  });
}
